import React from 'react'
import { Provider } from './Provider'

/**
 *
 */
export const Initializer = ({ value, children }) => {
  return <Provider value={{ ...value }}>{children}</Provider>
}
